import React, { useState } from "react";
import BillProposal from "../BillProposal/BillProposal";
import BillAddComment from "../BillAddComment/BillAddComment";
import css from "./DocumentPanel.module.css";
import Tiptap from "../TipTap/TipTap";

interface DocumentPanelProps {
  document?: any;
}

const DocumentPanel = ({ document }: DocumentPanelProps) => {
  const [showCommentForm, setShowCommentForm] = useState(false);

  return (
    <div className={css.root}>
      {/* This is just a dummy way to show the click -> show comment form interaction.
      In reality, the comment form will need to be inserted below the paragraph that
      the user has clicked on. */}
      <Tiptap doc={document} onSaveDocState={() => void 0} />
      {/*<div onClick={() => setShowCommentForm(!showCommentForm)} dangerouslySetInnerHTML={{__html: document.content}} />*/}
      {/* The author will probably be a user object, only the name is needed here,
      but maybe the initials will be stored and won't need to be extracted every time. */}
      {/*{showCommentForm && <BillAddComment author="Socially Active Team" />}*/}
      {/*{document.proposals && document.proposals.map((p, i) => <BillProposal proposal={p} key={i} />)}*/}
    </div>
  );
};

export default DocumentPanel;
